import baseDictionary from '../constants/localize/en_US';

export type Dictionary = Record<string, string>;

export let locale: Dictionary = baseDictionary;

export function setDictionary(dictionary: Dictionary): void {
  locale = {
    ...baseDictionary,
    ...dictionary,
  };
}

export type TranslationParams = Record<string, unknown>;

export function t(key: string, params?: TranslationParams): string {
  const template = locale[key] ?? key;
  if (!params) {
    return template;
  }
  return template.replace(
    /\{\{\s*([^{}\s]+)\s*\}\}|\{([^{}\s]+)\}/g,
    (placeholder, doubleBraceKey: string | undefined, singleBraceKey: string | undefined) => {
      const paramKey = doubleBraceKey ?? singleBraceKey;
      const value = params[paramKey];
      return value === undefined || value === null ? placeholder : String(value);
    }
  );
}
